// Account self-service for the logged-in staff user.

import { api } from './api-client';

/** Change the current user's password. 400 if the current password is wrong. */
export async function changePassword(
  currentPassword: string,
  newPassword: string,
): Promise<void> {
  await api.post('/auth/change-password', {
    current_password: currentPassword,
    new_password: newPassword,
  });
}

/**
 * Update the current user's profile — display name and/or avatar. Pass
 * `avatar_url: null` to remove the picture. At least one field is required.
 */
export async function updateProfile(body: {
  full_name?: string;
  avatar_url?: string | null;
}): Promise<void> {
  await api.patch('/auth/me', body);
}
